<template>
  <div>
    <CButton color="link" class="px-0 mb-2" @click="cancel">
      <CIcon name="cil-arrow-left" /> Users
    </CButton>
    <CCard class="mb-4">
      <CCardBody class="p-4">
        <h1 class="h4 mb-1 font-weight-bold">
          {{ obj.id ? obj.fullName || "User" : "New user" }}
        </h1>
        <p class="text-muted mb-0">{{ obj.id ? obj.email : "Give someone access to Niagaku" }}</p>
      </CCardBody>
    </CCard>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardBody>
            <div v-if="loadError" class="text-center p-5">
              <CIcon name="cil-warning" size="xl" class="text-danger mb-3" />
              <h2 class="h6 font-weight-bold">Couldn't load this user</h2>
              <p class="text-muted">Check your connection and try again.</p>
              <CButton color="primary" @click="resetObj">Retry</CButton>
            </div>
            <CForm v-else @submit.prevent="submit">
              <CInput label="Name *" horizontal v-model="obj.fullName" />
              <CSelect
                label="Role *"
                horizontal
                :options="roleOptions"
                :value.sync="obj.appUser.role"
              />
              <CInput
                label="Email *"
                type="email"
                horizontal
                v-model="obj.email"
                :readonly="isEmailReadOnly"
              />

              <CRow form class="form-group">
                <CCol tag="label" sm="3" class="col-form-label"> Set a new password </CCol>
                <CCol sm="9">
                  <CSwitch class="mr-1" color="primary" :checked.sync="isResetPassword" />
                </CCol>
              </CRow>
              <CInput
                v-if="isResetPassword"
                description="At least 8 characters, with a capital letter, a number and a special character."
                label="Password *"
                type="password"
                horizontal
                autocomplete="new-password"
                v-model="plainPassword"
              />
              <CRow form class="form-group">
                <CCol tag="label" sm="3" class="col-form-label"> Can sign in </CCol>
                <CCol sm="9">
                  <CSwitch class="mr-1" color="primary" :checked.sync="obj.isEnable" />
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-between">
            <CButton color="light" :disabled="saving" @click="cancel">Cancel</CButton>
            <CButton color="primary" :disabled="saving" @click="submit">
              {{ obj.id ? "Save" : "Add user" }}
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ProfileApi from "../../lib/profileApi";

export default {
  name: "User",
  data: () => {
    return {
      isResetPassword: false,
      plainPassword: "",
      isEmailReadOnly: false,
      roleOptions: [
        { value: "admin", label: "Admin" },
        { value: "normal", label: "Normal" },
      ],
      api: new ProfileApi(),
      obj: {
        fullName: "",
        appUser: {
          role: "normal",
        },
        email: "",
      },
      saving: false,
      loadError: false,
    };
  },
  mounted() {
    this.resetObj();
  },
  methods: {
    submit() {
      var self = this;
      if (self.saving) return;
      var profileDto = {
        profile: self.obj,
        isResetPassword: self.isResetPassword,
        plainPassword: self.plainPassword,
        role: self.obj.appUser.role,
      };
      const isNew = !self.obj.id;
      if (isNew && self.obj.appUser.role == null) self.obj.appUser.role = "normal";
      self.saving = true;
      const request = isNew
        ? self.api.createProfileAppUser(profileDto)
        : self.api.updateProfileAppUser(profileDto);
      request
        .then(() => {
          self.$toast.success(isNew ? "User added" : "User saved");
          self.$router.push({ path: "/admins/userList" });
        })
        .catch(({ data }) => {
          self.$toast.error("Couldn't save the user. " + helper.getErrorMessage(data));
        })
        .finally(() => {
          self.saving = false;
        });
    },
    resetObj() {
      var self = this;
      self.loadError = false;
      if (self.$route.params.id) {
        self.api
          .getProfile(self.$route.params.id)
          .then((response) => {
            self.obj = response.result;
          })
          .catch((error) => {
            console.error(error);
            self.loadError = true;
          });
      } else {
        self.obj = self.getEmptyObj();
        self.isResetPassword = true;
      }
    },
    getEmptyObj() {
      return {
        fullName: "",
        email: "",
        appUser: {
          role: "normal",
        },
      };
    },
    cancel() {
      this.$router.push({ path: "/admins/userList" });
    },
  },
};
</script>
